import { memo } from 'react'
import { 
  UserIcon, 
  EnvelopeIcon, 
  ChatBubbleLeftIcon,
  TruckIcon 
} from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'

/**
 * ContactSubmissionDetails - Displays contact submission information
 * Shows name, email, message, and vendor-specific fields if applicable
 */
const ContactSubmissionDetails = memo(function ContactSubmissionDetails({
  contact
}) {
  const navigate = useNavigate()
  
  return (
    <div className="space-y-4 border-t pt-4">
      {/* Contact Details */}
      <div className="flex items-start">
        <UserIcon className="h-5 w-5 mr-3 text-gray-400 mt-0.5" />
        <div>
          <div className="text-sm text-gray-500">Name</div>
          <div className="text-gray-900">{contact.name}</div>
        </div>
      </div>

      <div className="flex items-start">
        <EnvelopeIcon className="h-5 w-5 mr-3 text-gray-400 mt-0.5" />
        <div>
          <div className="text-sm text-gray-500">Email</div>
          <a href={`mailto:${contact.email}`} className="text-gray-900 hover:text-primary">
            {contact.email}
          </a>
        </div>
      </div>

      {/* Message */}
      <div className="flex items-start">
        <ChatBubbleLeftIcon className="h-5 w-5 mr-3 text-gray-400 mt-0.5" />
        <div className="flex-1">
          <div className="text-sm text-gray-500 mb-2">Message</div>
          <div className="text-gray-900 whitespace-pre-wrap bg-gray-50 p-4 rounded-lg">
            {contact.message}
          </div>
        </div>
      </div>

      {/* Vendor-specific fields */}
      {contact.isVendor && (
        <div className="border-t pt-4">
          <h3 className="font-semibold text-gray-900 mb-3">Vendor Information</h3>
          
          {contact.vendorIntent && (
            <div className="mb-3">
              <div className="text-sm text-gray-500">Request Type</div>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                {contact.vendorIntent}
              </span>
            </div>
          )}

          {contact.entityName && (
            <div className="mb-3">
              <div className="text-sm text-gray-500">Entity Name</div>
              <div className="text-gray-900">{contact.entityName}</div>
            </div>
          )}

          {contact.entityId && (
            <div>
              <div className="text-sm text-gray-500">Entity ID</div>
              <div className="text-gray-900 font-mono text-sm">{contact.entityId}</div>
              <button
                onClick={() => navigate(`/entities/${contact.entityId}`)}
                className="text-sm text-primary hover:text-primary-600 mt-1"
              >
                View Entity →
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
})

export default ContactSubmissionDetails
